import type { FundingSourceKind, FundingSourceStatus } from '../types';

export const KIND_LABEL: Record<FundingSourceKind, string> = {
  grant: 'Grant',
  discount: 'Insurance discount',
};

// Both 'open' and 'rolling' read as "something a person can act on today" —
// the discount is always available through an insurer, which is why it's
// the only program with a green status in the seeded four.
export const STATUS_META: Record<FundingSourceStatus, { label: string; open: boolean }> = {
  open: { label: 'Open now', open: true },
  rolling: { label: 'Open now, on a rolling basis', open: true },
  closed: { label: 'Not open right now', open: false },
  unannounced: { label: 'Next round not announced', open: false },
};
